import React, { useEffect, useState } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import { Label } from "./styles";
import dayjs from "dayjs";
import { DATE_TIME_FORMAT } from "../../utils/constants";
const DatePickerInput = ({
  labelText,
  id,
  name,
  error,
  helperText,
  value,
  disabled,
  onChange,
  minDate = null,
  maxDate = null,
  disablePast = true,
  ...restInputProps
}) => {
  const [selectedDate, setSelectedDate] = useState(value ? dayjs(value) : null);
  useEffect(() => {
    setSelectedDate(value ? dayjs(value) : null);
  }, [value]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="tma__input_container tma_date_container">
        <Label htmlFor={id}>{labelText}</Label>
        <DatePicker
          value={selectedDate}
          disablePast={disablePast}
          disabled={disabled}
          format={DATE_TIME_FORMAT.PICKER}
          minDate={dayjs(minDate)}
          maxDate={dayjs(maxDate)}
          slotProps={{
            textField: {
              id,
              variant: "outlined",
              error,
              name,
              helperText,
              ...restInputProps,
              inputProps: {
                readOnly: true,
                placeholder: DATE_TIME_FORMAT.PICKER, // This explicitly sets the placeholder
                ...(restInputProps ?.inputProps || {}),
              },
            },
          }}
          onChange={(newValue) => {
            setSelectedDate(newValue);
            onChange(newValue.toDate());
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </div>
    </LocalizationProvider>
  );
};

export { DatePickerInput };
